// @ts-nocheck
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { WallPost, WallPostAuthor } from './useWallFeed';

export function usePinnedPost(profileId: string | undefined) {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: ['pinned-post', profileId],
    queryFn: async () => {
      if (!profileId) return null;

      const { data, error } = await supabase
        .from('wall_posts')
        .select(`
          id,
          content,
          media_urls,
          hashtags,
          created_at,
          updated_at,
          profile_id,
          comments_count,
          likes_count,
          reactions_count,
          share_count,
          post_type,
          is_pinned,
          is_boosted,
          profiles!wall_posts_profile_id_fkey (
            id,
            first_name,
            last_name,
            username,
            avatar_url
          )
        `)
        .eq('profile_id', profileId)
        .eq('is_pinned', true)
        .eq('is_hidden', false)
        .maybeSingle();

      if (error) throw error;
      if (!data) return null;

      const profileData = Array.isArray(data.profiles) ? data.profiles[0] : data.profiles;

      return {
        ...data,
        media_urls: data.media_urls as string[] | null,
        hashtags: data.hashtags as string[] | null,
        reactions_count: data.reactions_count as Record<string, number> | null,
        author: profileData as WallPostAuthor,
      } as WallPost;
    },
    enabled: !!profileId,
  });

  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: ['pinned-post', profileId] });
    queryClient.invalidateQueries({ queryKey: ['user-posts', profileId] });
  };

  return {
    ...query,
    invalidate,
  };
}
